import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/BgImg06.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2>
                Create a Highly Scalable Flutter App with a Premier Flutter
                Development Company
              </h2>
            </div>
            <p>
              TekRevol is your go-to choice for professional Flutter application
              development. Every iOS, Android, and web app designed by our
              Flutter engineer is a perfect reflection of the brand it
              represents. We are a Flutter development agency in UK that
              guarantees that all of the tech stack and tools used in your apps
              are extremely flexible, allowing your users to have a native-like
              app on every device they use.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Schedule A Free Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
